import Firestore from '../initFirebase'
import { globalOnDemandVars } from '../../helper/context'
import {
  handleErrorInCatch,
  notSavedInAnonymous,
  notSavedInSharing,
  savingEnd,
  savingStart
} from '../../helper/functions'

export async function updateMediaItemF (id, input) {
  if (globalOnDemandVars.isSharing()) {
    notSavedInSharing()
    return
  }
  if (globalOnDemandVars.userData().isAnonymous) {
    notSavedInAnonymous()
    return
  }

  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'updateMediaItemF 시작',
      value: {
        globalId: id,
        input
      }
    // , important: true
    })
  }
  try {
    savingStart()
    await Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('MediaItems').doc(id).update(input).then(() => {
      if (process.env.NODE_ENV !== 'production') {
        console.tron.log('updateMediaItemF')
      }
    })
    savingEnd()
  } catch (e) {
    handleErrorInCatch(e, 'updateData.js')
  }
  // const result = await client.mutate(buildMutation(client,
  //   gql(updateMediaItem),
  //   {
  //     inputType: gql(UpdateMediaItemInput),
  //     variables: {
  //       input: {
  //         id,
  //         ...input
  //       }
  //     }
  //   },
  //   (_variables) => [ gql(getMediaItem) ],
  //   'MediaItem'))

  // console.tron.display({
  //   name: 'updateMediaItem',
  //   preview: id,
  //   value: {
  //     result: Firestore.collection('MediaItems').doc(id).get().data()
  //   }
  //   // , important: true
  // })
}
